<ng-container *ngIf="tiempoEspera.consulta.sta_id == 114 || tiempoEspera.consulta.sta_id == 120">
  <!-- SOLO visible en pantallas medianas o mayores -->
  <div class="d-none d-md-block">
    <div class="card p-1" (click)="redirectToFilaEspera()"
      style="background-color: #fff; border-radius: 20px; box-shadow: 0 0 6px rgba(43, 171, 183, 0.5) !important; min-height: 70px; cursor: pointer;">
      <div class="row justify-content-center m-0 w-100" style="gap: 5px; display: flex; flex-wrap: nowrap;">

        <!-- Solo visible en pantallas grandes -->
        <div class="col-lg-3 d-none d-lg-flex p-0 text-center flex-column justify-content-center">
          <p class="text-truncate-text" style="font-size: 12px;"><b>Atención</b></p>
          <p class="text-truncate-text" style="font-size: 12px;"><b>Inmediata</b></p>
        </div>

        <!-- Card: Lugar en la fila -->
        <div class="col-lg-4 col-5 p-0 d-flex align-items-center">
          <div class="card m-0 p-2 d-flex align-items-center justify-content-center w-100"
            style="background-color: #D5FFF7; border-radius: 12px;">
            <div class="col-3 p-0 d-flex justify-content-center align-items-center">
              <mat-icon style="color: #000;">person_outline</mat-icon>
            </div>
            <div class="col-6 p-0 d-flex align-items-center flex-column">
              <p class="text-light-truncate w-100 text-center" style="font-size: 12px;"><b>Lugar</b></p>
              <p class="text-light-truncate w-100 text-center" style="font-size: 12px;">en la fila:</p>
            </div>
            <div class="col-3 p-0 d-flex justify-content-end align-items-center">
              <span class="fw-bold text-truncate" style="font-size: 16px;">{{ tiempoEspera.data.posicion }}</span>
            </div>
          </div>
        </div>

        <!-- Card: Tiempo de espera -->
        <div class="col-lg-4 col-5 p-0 d-flex align-items-center">
          <div class="card m-0 p-2 d-flex align-items-center justify-content-center w-100"
            style="background-color: #D5FFF7; border-radius: 12px;">
            <div class="col-3 p-0 d-flex justify-content-center align-items-center">
              <mat-icon style="color: #000;">schedule</mat-icon>
            </div>
            <div class="col-6 p-0 d-flex align-items-center flex-column">
              <p class="text-light-truncate w-100 text-center" style="font-size: 12px;"><b>Minutos</b></p>
              <p class="text-light-truncate w-100 text-center" style="font-size: 12px;">de espera:</p>
            </div>
            <div class="col-3 p-0 d-flex justify-content-end align-items-center">
              <span class="fw-bold text-truncate" style="font-size: 16px;" >{{ redondearTiempo(tiempoEspera.data.tiempoEspera) }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="tiempoEspera.consulta.sta_id == 114 || tiempoEspera.consulta.sta_id == 120">

  <div class="row d-md-none d-sm-flex justify-content-center" (click)="redirectToFilaEspera()">
    <div class="card col-12" style="box-shadow: 0 0 10px rgba(43, 171, 183, 0.5) !important; gap: 5px !important; padding: 10px !important;">
      <div class="col-3 p-0 text-center">
        <mat-icon style="color: #000; font-size: 20px;     padding-top: 8px !important;">directions_walk</mat-icon>
      </div>
      <div class="col-9 p-0 text-center">
        <span
          style="font-weight: bold; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ redondearTiempo(tiempoEspera.data.tiempoEspera) }} min
        </span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="tiempoEspera.consulta.sta_id == 116">
  <div class="card d-none d-md-flex" (click)="redirectToSalaEspera()"
    style="background-color: #fff; border-radius: 20px; box-shadow: 0 0 6px rgba(43, 171, 183, 0.5) !important; min-height: 70px; display: flex; justify-content: center;">
    
    <div class="row justify-content-center w-100 m-0">
      <!-- Solo visible en pantallas medianas en adelante -->
      <div class="col-md-3 d-md-none d-lg-flex text-center flex-column justify-content-center p-0">
        <p class="text-truncate-text" style="font-size: 14px;"><b>Atención</b></p>
        <p class="text-truncate-text" style="font-size: 14px;"><b>Inmediata</b></p>
      </div>

      <!-- Se ajusta a col-12 en pantallas pequeñas -->
      <div class="col-lg-8 col-12 p-0">
        <div class="card p-2 d-flex flex-column align-items-center justify-content-center"
          style="background-color: #D5FFF7; border-radius: 20px; box-shadow: 2px 2px 5px rgba(0,0,0,0.2); cursor: pointer;">
          
          <div class="d-flex align-items-center w-100">
            <div class="p-0 d-flex justify-content-center" style="margin-left: 10px;">
              <mat-icon style="color: #000;">directions_walk</mat-icon>
            </div>
            <div class="text-content-truncate">
              <span class="text-bold-truncate" >{{msjTittleTurno}}</span>
              <span class="text-light-truncate" >{{mensajeSubTittleTurno}}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-container>



<ng-container *ngIf="tiempoEspera.consulta.sta_id == 116">

  <div class="row d-md-none d-sm-flex justify-content-center" (click)="redirectToSalaEspera()">
    <div class="card col-12" style="box-shadow: 0 0 10px rgba(43, 171, 183, 0.5) !important; gap: 0 !important">
      <div class="col-4 p-0 text-center">
        <mat-icon style="color: #000; font-size: 20px;">directions_run</mat-icon>
      </div>
      <div class="col-4 p-0 text-center">
        <mat-icon style="color: #000; font-size: 20px;">chevron_right</mat-icon>
      </div>
      <div class="col-4 p-0 text-center">
        <mat-icon style="color: #000; font-size: 20px;">video_call</mat-icon>
      </div>
    </div>
  </div>
</ng-container>